import { Link } from 'react-router-dom';

/**
 * NavItem — ítem del menú lateral con la animación estilo logo ONOR:
 * corchetes [ ] que se abren en hover/activo, iluminación (glow) y cambio
 * al color primary (themeable por el usuario). Los estilos viven en la
 * clase .nav-athletic de index.css.
 *
 * Props: to, icon (componente lucide), label, active, onClick, testId
 */
const NavItem = ({ to, icon: Icon, label, active = false, onClick, testId }) => (
  <Link
    to={to}
    onClick={onClick}
    className={`nav-athletic ${active ? 'is-active' : ''}`}
    data-testid={testId}
  >
    {Icon && <Icon className="nav-ico w-5 h-5 shrink-0" />}
    <span className="font-body text-sm inline-flex items-center">
      <span className="brk brk-l" aria-hidden="true">[</span>
      <span>{label}</span>
      <span className="brk brk-r" aria-hidden="true">]</span>
    </span>
  </Link>
);

export default NavItem;
